export default __webpack_public_path__ + "static/media/secureTransport.fefe1d50.svg";